import {useState, useEffect, createElement, Suspense} from "react";
import {Paysafe} from "parts/paywall";
import {Checkbox, Spinner} from "parts";
import {useTranslation} from "react-i18next";
import {setProfile, setRegister, setTrack} from "utils";
import {PaymentPayPal, PaymentStripeWallet, PaymentStripeCard} from "./LazyPayments"

export function Payment({children, data, nextUrl, prefix = '', paymentType, onPayReady, paywallType = 'standard', one = false}) {
  const {t, i18n} = useTranslation('common', {keyPrefix: 'payment'})

  const
    [resetTrigger, setResetTrigger] = useState(0),
    [paymentIndex, setPaymentIndex] = useState(0),
    [productData, setProductData] = useState()
    // [why, setWhy] = useState(false),

    // A55 =
    //   window.landing === LandingEnum.default && i18n.resolvedLanguage === 'en'
    //     ? getExperiment('A55')
    //     : {value: 'A'},

    // A85 =
    //   window.landing === LandingEnum.default && i18n.resolvedLanguage === 'en'
    //     ? getExperiment('A85')
    //     : {value: 'A'},

    // AR98 = getExperiment('AR98', 'A')

  useEffect(() => setPaymentIndex(0), [resetTrigger])

  useEffect(() => {
    if (!data)
      return

    if (!window._uid && !window.localStorage.getItem('uid')) { // WTF case
      setTrack('checkout_error', {message: 'payment without uid'})

      if (!window.sessionStorage.getItem('reload')) {
        window.sessionStorage.setItem('reload', '1')
        window.location.reload()
        return
      }
    }

    setProductData({
      ...data,
      // uid: null,
      // email: '',
      uid: window._uid || window.localStorage.getItem('uid'),
      email: window._email || window.localStorage.getItem('email') || '',
      paywall_type: paywallType,
    })

    if (!one) {
      const product = `${data.name.replace(' ', '')}_${data.fullPrice}`
      setRegister({product})
      setProfile({product, plan: data.period})
      // mixpanel.track_pageview({page: 'payment'})
      // mixpanel.track('payment')
      // window.localStorage.setItem('product', product)
    }
  }, [data])

  useEffect(() => {
    if (!paymentType)
      return

    const index =
      paymentList.findIndex(({pay, credit}) =>
        (paymentType === 'credit' && credit) ||
        (paymentType === 'applePay' && pay)
      )

    if (index >= 0)
      setPaymentIndex(index)
  }, [paymentType])

  useEffect(() => {
    for (const item of paymentList) {
      if (item.applePay)
        item.name = t('applePay')
      else if (item.googlePay)
        item.name = t('googlePay')
      else if (item.paypal)
        item.name = t('payPal')
      else if (item.credit)
        item.name = t('credit')
    }

    setPaymentList([...paymentList])
  }, [i18n.resolvedLanguage])

  // useEffect(() => {
  //   const remove = () => {
  //     document.body.classList.remove('pop');
  //     document.querySelectorAll('.shadow').forEach(e => e.remove());
  //   };
  //
  //   if (why) {
  //     document.body.classList.add('pop');
  //
  //     const div = document.createElement('div');
  //     div.classList.add('shadow');
  //     document.body.append(div);
  //   } else
  //     remove();
  //
  //   return remove;
  // }, [why]);

  const check = <img src={'/static/img/icon/check.svg'} loading={'lazy'} width={12} height={8} alt={''}/>

  const [paymentList, setPaymentList] = useState([
    {
      name: '...',
      pay: true,
      component: PaymentStripeWallet,
    },
    {
      name: t('payPal'),
      paypal: true,
      img: <img src={'/static/img/paywall/paypal-pay.png'} loading={'lazy'} width={52} height={20} alt={t('payPal')} />,
      component: PaymentPayPal,
    },
    {
      name: t('credit'),
      credit: true,
      img: <img src={'/static/img/paywall/card-pay.png'} loading={'lazy'} width={207} height={20} alt={t('credit')} />,
      component: PaymentStripeCard,
    },
  ])

  useEffect(() => {
    // if (!window.userSelectPayemnt) {
    //   window.userSelectPayemnt = true
    //   return
    // }

    const
      pay = paymentList[paymentIndex],
      type = pay.credit ? 'Card' : pay.name

    if (type !== '...')
      setTrack('payment_method_selected', {type})
  }, [paymentIndex])

  function handleStripeResult(result) {
    // console.log('handleStripeResult', result)

    const pIndex = paymentList.findIndex(({pay}) => pay)

    if (pIndex >= 0) {
      let type = null

      if (result?.applePay) {
        type = 'applePay'
        paymentList[pIndex] = {
          ...paymentList[pIndex],
          applePay: true,
          name: t(type),
          img: <img src={'/static/img/paywall/apple-pay.png'} loading={'lazy'} width={35} height={20} alt={t('applePay')}/>,
        }
        setTrack('payment_method_selected', {type: 'Apple Pay'})
      } else if (result?.googlePay) {
        type = 'googlePay'
        paymentList[pIndex] = {
          ...paymentList[pIndex],
          googlePay: true,
          name: t(type),
          img: <img src={'/static/img/paywall/google-pay.png'} loading={'lazy'} width={35} height={20} alt={t('googlePay')}/>,
        }
        setTrack('payment_method_selected', {type: 'Google Pay'})
      } else
        paymentList.splice(pIndex, 1)

      setPaymentList([...paymentList])

      if (onPayReady)
        onPayReady(type)
    }
  }

  const
    periods = t('periods', {returnObjects: true}),
    getPeriod = (field, first, period) => {
      if (!period)
        period = data?.period

      return periods[period]?.[first] || periods[period]?.[field] || period
    }

  if (one) {
    if (!productData)
      return

    return (
      <Suspense fallback={<Spinner/>}>
        {createElement(PaymentStripeWallet, {
          data: productData,
          options: {
            buttonTheme: {
              applePay: 'white',
            }
          },
          // onResult: handleStripeResult,
          nextUrl,
          paymentType,
          one,
          onResetPayment: () => setResetTrigger(prev => prev + 1)
        })}
      </Suspense>
    )
  }

  return (
    <div id={'payment'} className={'block items text-start'}>
      <div className={'row wide'}>
        <strong>{t('title')}</strong>
        {/*<em role={'button'} className={'note md'} onClick={() => setWhy(true)}>Why now?</em>*/}
      </div>

      {
        // why &&
        // <div className={'window'}>
        //   <div className={'items'}>
        //     <p className={'notice'}>We ask for your payment information now so you can enjoy Simple uninterrupted after your 30-day trial ends.</p>
        //     <p className={'notice'}>If you cancel anytime before the end of the 30-day trial, you won't be charged.</p>
        //     <Button onClick={() => setWhy(false)}>Got it</Button>
        //   </div>
        // </div>
      }

      <hr/>

      {
        // A85.value === 'A' &&
        // !data?.discount && paywallType !== 'renewal' &&
        // <p className={'notice'}>
        //   {t('notice', {
        //     currencySymbol: data?.currencySymbol,
        //     fullPrice: data?.fullPrice,
        //     period: getPeriod('text')
        //   })}
        // </p>
      }

      {
        paymentList.map((item, index) => {
          const checked = paymentIndex === index

          return (
            <div key={index} className={'block-plan items' + (checked ? ' active' : '')} onClick={() => setPaymentIndex(index)}>
              <div className={'item'}>
                {
                  paymentList.length > 1 &&
                  <Checkbox type={'radio'} name={'plan' + (index ? '-' + index : '')} checked={checked} readOnly={true}/>
                }
                <div className={'w-100 text-start'}>
                  <strong>{item.name}</strong>
                  {
                    item.credit &&
                    <p className={'mt-1'}>{item.img}</p>
                  }
                </div>
                {!item.credit && item.img}
              </div>
              {
                checked && item.pay &&
                <div className={'items md small'}>
                  <div className={'row sm'}>{check}<em>{item.applePay ? t('easyApple') : t('easy')}</em></div>
                  <div className={'row sm'}>{check}<em>{t('encryption')}</em></div>
                  <div className={'row sm'}>{check}<em>{t('accountNumber', {name: item.name})}</em></div>
                </div>
              }
              {
                checked && item.paypal &&
                <div className={'items md small'}>
                  <div className={'row sm'}>{check}<em>{t('fast')}</em></div>
                  <div className={'row sm'}>{check}<em>{t('encryption')}</em></div>
                  <div className={'row sm'}>{check}<em>{t('protection')}</em></div>
                </div>
              }
              {
                checked && item.component && productData &&
                <Suspense fallback={<Spinner/>}>
                  {createElement(item.component, {
                    data: productData,
                    onResult: handleStripeResult,
                    nextUrl,
                    onResetPayment: () => setResetTrigger(prev => prev + 1)
                  })}
                </Suspense>
              }
              {
                checked && (item.paypal || item.credit) &&
                <Paysafe payment={true}/>
              }
            </div>
          )
        })
      }

      {children}
      {
        !children && data?.price &&
        <>
          <p className={'notice sm'}>
            {t(prefix + 'subscription', {
              period: getPeriod('value', 'value-1'),
              dialect: getPeriod('dialect'),
                // AR98.value === 'B' && data?.period === '1week'
                //   ? getPeriod('dialect', 'dialect', '1month')
                //   : getPeriod('dialect'),
              currency: data?.currency,
              price: data?.price
            })}
          </p>

          <Paysafe>{t('checkout')}</Paysafe>
          <img width={326} height={30} src={'/static/img/paywall/logos-2.png'} loading={'lazy'} alt={t('checkout')}/>
          {
            // A85.value === 'B'
            //   ?
            //   <>
            //     <Paysafe>Guaranteed Safe Checkout</Paysafe>
            //     <img width={326} height={30} src={require('assets/img/paywall/logos-2.png')} alt={'Guaranteed Safe Checkout'}/>
            //   </>
            //   :
            //   <div className={'row sm'}>
            //     {check}<em className={'small'}>{t(prefix + 'specialPrice', {
            //     period: getPeriod('value'),
            //     currencySymbol: data?.currencySymbol,
            //     fullPrice: data?.fullPrice
            //   })}</em>
            //   </div>
          }
        </>
      }
    </div>
  )
}